import React, { forwardRef } from 'react';

export const DraggableItem = forwardRef<any, any>((props, ref) => {
    return (
        <div {...props} ref={ref}>
            {props.children}
        </div>
    );
});